"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const AuthFormOverlayContent = styled_components_1.default.div(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    padding: 4,
    '.auth-form-title': theme.auth.formTitleStyles,
    '.auth-form-text': theme.auth.formTextStyles,
}));
const AuthFormOverlay = props => {
    const { title, text, children } = props;
    return (react_1.default.createElement(AuthFormOverlayContent, null,
        title ? (react_1.default.createElement("h2", { className: "auth-form-title", "data-id": "auth-form-title" }, title)) : null,
        text && (react_1.default.createElement("div", { className: "auth-form-text", "data-id": "auth-form-text", dangerouslySetInnerHTML: { __html: text } })),
        children));
};
exports.default = AuthFormOverlay;
//# sourceMappingURL=AuthFormOverlay.js.map